// variables.js
export const scale = "scale(1.3)";
export const settings = {
  some: "Settings"
}